import React, { createContext, useContext, useMemo } from 'react'
import { isArray, pick } from 'lodash-es'
import { createStore, useStore } from 'zustand'

import shallow from 'zustand/shallow'

const Context = createContext()

export const useDittoStore = (selectors, equalityFn = shallow) => {
  const store = useContext(Context)
  if (store === null) {
    throw new Error('no provider')
  }
  if (isArray(selectors)) {
    return useStore(store, (x) => pick(x, selectors), equalityFn)
  }
  return useStore(store, selectors, equalityFn)
}

const Wrapper = ({
  appId,
  ditto,
  tbId,
  onFetchRemoteData,
  upload,
  addWatermarkToImage,
  beforeTransform,
  extendDitto,
  children,
}) => {
  const store = useMemo(
    () =>
      createStore(() => ({
        tbId,
        ditto,
        upload,
        appId,
        addWatermarkToImage,
        onFetchRemoteData,
        beforeTransform,
        extendDitto,
      })),
    [tbId]
  )
  return <Context.Provider value={store}>{children}</Context.Provider>
}

export const DittoProvider = ({
  appId,
  children,
  ditto,
  tbId,
  upload,
  addWatermarkToImage,
  beforeTransform,
  onFetchRemoteData,
  extendDitto,
}) => {
  return (
    <Wrapper
      appId={appId}
      ditto={ditto}
      tbId={tbId}
      onFetchRemoteData={onFetchRemoteData}
      upload={upload}
      addWatermarkToImage={addWatermarkToImage}
      beforeTransform={beforeTransform}
      extendDitto={extendDitto}
    >
      {children}
    </Wrapper>
  )
}
